import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import SVG from 'react-inlinesvg'
import downloadIcon from '@icons/download/primary'

const downloadFile = (url, filename) => {
  const a = document.createElement('A');
  a.href = url;
  a.download = filename || '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

const createAndDownloadFile = (data, filename, type) => {
  const file = new Blob([data], { type });
  const url = URL.createObjectURL(file);
  downloadFile(url, filename);
  URL.revokeObjectURL(url);
}

const PasswordsDownloadButton = ({ filename, students, children, ...rest }) => {
  const objects = _.values(students);
  const download = (_e) => {
    const data = [
      [
        I18n.t('parent_students.common.first_name'),
        I18n.t('parent_students.common.last_name'),
        I18n.t('parent_students.common.login'),
        I18n.t('parent_students.common.password')
      ].join(','),

      ..._.map(objects, (student) => {
        const { object } = student
        return `${object.name},${object.surname},${object.login},${object.password}`
      })
    ]

    return createAndDownloadFile(
      data.join('\n'),
      filename,
      'text/csv'
    );
  }

  return (
    <a href="javascript:void(0)" onClick={download} className="link link--icon-left f--upper" {...rest}>
      { children ? children : (
          <Fragment>
            <SVG src={downloadIcon} />
            {I18n.t('groups.passwords.download')}
          </Fragment>
        ) }
    </a>
  )
}

PasswordsDownloadButton.propTypes = {
  filename: PropTypes.string.isRequired,
  students: PropTypes.array.isRequired
}

export default PasswordsDownloadButton
